import { render, staticRenderFns } from "./CaseStudyVivoOnline.vue?vue&type=template&id=4b6a5ee6&scoped=true"
import script from "./CaseStudyVivoOnline.vue?vue&type=script&lang=js"
export * from "./CaseStudyVivoOnline.vue?vue&type=script&lang=js"
import style0 from "./CaseStudyVivoOnline.vue?vue&type=style&index=0&id=4b6a5ee6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6a5ee6",
  null
  
)

export default component.exports